import mixpanel from "./mixpanel";

export const trackButtonClick = (buttonName, userInfo, clickIntent, buttonType) => {
  mixpanel.track("Button Click", {
    button_name: buttonName,
    button_type: buttonType,
    page_url: window.location.href,
    user_type: userInfo
      ? userInfo.isAdmin
        ? "Admin"
        : userInfo.isVideographer
        ? "Videographer"
        : "Generic User"
      : "Unauthenticated User",
    timestamp: new Date().toISOString(),
    os: navigator.platform,
    click_intent: clickIntent,
  });
};
